// material-ui
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

// project imports
import Search from './Search';

// assets
import { LogoutOutlined } from '@ant-design/icons';

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));

  const handleLogout = () => {
    // TODO: wire up actual logout / auth clear logic here
    window.location.href = '/login';
  };

  return (
    <>
      {!downLG && <Search />}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      <Button
        variant="contained"
        size="small"
        startIcon={<LogoutOutlined />}
        onClick={handleLogout}
        sx={{
          ml: 1,
          whiteSpace: 'nowrap',
          bgcolor: '#ffffff',
          color: '#1e2a4a',
          fontWeight: 600,
          '&:hover': { bgcolor: '#f0f0f0' }
        }}
      >
        Logout
      </Button>
    </>
  );
}
